import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Grid from '@material-ui/core/Grid';

import UserInfo from './UserInfo';
import Profile from './Profile';
import Bulletin from './Bulletin';
//import BulletinNew from './BulletinNew';
import ManageUser from './ManageUser';
import ManageGroup from './ManageGroup';
import OnCallScheduleList from './OnCallScheduleList';
import Announcement from './Announcement';
import AnnouncementMessage from './AnnouncementMessage';

import { logoutUser } from '../actions/logout_actions';
import getProfileFetch from '../actions/profile_actions';
import windowActions from '../actions/window_actions';
import userActions from '../actions/user_actions';

import { connect } from 'react-redux';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Tooltip from '@material-ui/core/Tooltip';
import MenuIcon from '@material-ui/icons/Menu';
import IconButton from '@material-ui/core/IconButton';
import NewWindow from 'react-new-window';

class UserHub extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      anchorEl: null,
      announcements: [],
      logoutClicked: false,
      profile: this.props.profile,
      showBulletin: false,
      showUserManager: false,
      showGroupManager: false,
      showMakeAnnouncement: false,
      /**/
      features: {
        width: 800,
        height: 490,
        top: window.screenTop,
        left: window.screenLeft + 205 + 434 + 5, // window.innerWidth + 434 + 10, // some space + 10 // window is not 450 on test site
        screenX: window.screenX + 205 + 434 + 5, // window.innerWidth + 434 + 10, // some space + 10
        screenY: window.screenY
      },
      salesFeatures: {
        width: 1000,
        height: 700
      },
      userManagerfeatureSize: {
        width: 750, // 700,
        height: 675
      },
      groupManagerfeatureSize: {
        width: 590, // 700,
        height: 365
      },
      announcementfeatureSize: {
          width: 500,
          height: 335 //
      },
      announcementMessagefeatureSize: {
          width: 545,
          height: 80
      },
    };
  }

  componentDidMount() {
      setTimeout(function () {
          if (localStorage.getItem("token") !== null) {
              this.props.hub.on('NewAnnouncement', (announcement => {
                  console.log("We got a new announcement");
                  console.log(announcement);
                  var newAnnouncements = this.state.announcements.splice();
                  newAnnouncements.push(announcement.payload);
                  this.setState({ 'announcements': newAnnouncements });
              }));
          }
      }.bind(this), 5000);
  };

  closeChatWindowLogout = () => {
    this.props.callbackFromParentLogout(this.state.logoutClicked);
  }

  handleClickMainMenu = (event) => {
      this.setState({ anchorEl: event.currentTarget }); // 

      console.log("UserHub Props: ", this.props);
  };

  handleCloseMainMenu = () => {
    this.setState({ anchorEl: null });
  };

  flashNotification = (protocol, action, params) => {
    console.log("flash protocol called");
    var e = document.createElement('a');
    e.id = 'flashNotification';
    var strParams = "";
    if (typeof params !== 'undefined') {
      Object.keys(params).forEach(function (key) {
        strParams += strParams !== "" ? '&' : '';
        strParams += key + '=' + encodeURI(params[key]);
      });
    }
    e.href = strParams.length > 0 ? protocol + '://' + action + '?' + strParams : protocol + '://' + action;
    document.getElementsByTagName('body')[0].appendChild(e);
    e.click();
    e.parentNode.removeChild(e);
  };

  handleClickLogout = (event) => {
      event.preventDefault();
      this.setState({ anchorEl: null });
      this.flashNotification('teamx', 'flashstop');
      if (window.open("", "ChatBoxWindow") !== null && window.open("", "Bulletin") !== null && window.open("", "MakeAnnouncement") !== null && window.open("", "Announcement") !== null && window.open("", "UserManager") !== null && window.open("", "GroupManager") !== null) {
          window.open("", "ChatBoxWindow").close();
          window.open("", "Bulletin").close();
          window.open("", "MakeAnnouncement").close();
          window.open("", "Announcement").close();
          window.open("", "UserManager").close();
          window.open("", "GroupManager").close();
      }
      this.props.setChatDisplay(false);

      var updatedUser = { ...this.props.profile };
      updatedUser["status"] = "Done";
      updatedUser["inOffice"] = false;
      updatedUser["stamp"] = "validLogout";
      this.props.updateProfile(updatedUser);
      //this.props.updateLastSeen();
      localStorage.removeItem("token"); // Remove the token from localStorage
      console.log("token removed? ", localStorage.getItem("token"));
      this.props.logoutUser(); // Remove the user object from the Redux store
      setTimeout(() => window.location.reload(), 1000);
  };

  handleCloseMainMenuCallback = () => {
    this.setState({ anchorEl: null });
  };

    handleShowBulletin = () => {
        console.log("inside handle open bulletin");
        //this.props.updateBulletin(true);
        if (this.state.showBulletin) {
            this.handleCloseBulletin();
            console.log("after handle close bulletin");
        this.setState({ showBulletin: false }, () => { this.setState({ showBulletin: true }); }); // closes and reopens the bulletin
           // window.open('', 'BulletinWindow', '').focus(); // bring bulletin into focus but does not reload it
            window.open("", "BulletinWindow", "location=0").focus();
    } else {
        this.setState({ showBulletin: true });
    }
  };

    handleCloseBulletin = () => {
        console.log("inside handle close bulletin");
      window.open('', 'BulletinWindow', '').close();
      this.setState({ showBulletin: false, anchorEl: null });

  };

  handleShowUserManager = () => {
    this.setState({ showUserManager: true });
  };

  handleCloseUserManager = () => {
    this.setState({ showUserManager: false, anchorEl: null });
  };

  handleShowGroupManager = () => {
    this.setState({ showGroupManager: true });
  };

  handleCloseGroupManager = () => {
    this.setState({ showGroupManager: false, anchorEl: null });
  };

  handleShowMakeAnnouncement = () => {
    this.setState({ showMakeAnnouncement: true });
  };

  handleCloseMakeAnnouncement = () => {
    this.setState({ showMakeAnnouncement: false, anchorEl: null });
  };

  closeAnnouncement = (announcement) => () => {
    var newAnnouncements = [];
    for (var i = 0; i < this.state.announcements.length; i++) {
      if (this.state.announcements[i]['message'] === announcement['message']) {
        continue;
      }
      newAnnouncements.push(this.state.announcements);
    }
    this.setState({ 'announcements': newAnnouncements });
  };

  render() {
    const { anchorEl } = this.state;
    let onCallSchedule;
    let bulletin;
    let featureSize;
    let userManager;
    let groupManager;
    let announcement;
    let userManagerMenuItem;
    let groupManagerMenuItem;

    // prevents undefined error
    let userRoles = this.props.profile.roles || "";

    if (userRoles.includes("S")) {
      featureSize = this.state.salesFeatures;
    } else {
      featureSize = this.state.features;
    }

    if (this.state.showBulletin === true) {
      bulletin =
        <NewWindow title={'Bulletin'} name={'Bulletin'} onUnload={this.handleCloseBulletin} center='screen' features={featureSize}>
          <Bulletin profile={this.props.profile} />
        </NewWindow>;
    }

    if (userRoles.includes("A")) {
      userManagerMenuItem =
        <MenuItem onClick={this.handleShowUserManager} style={{ padding: '5px 10px', fontSize: '12px', minHeight: '25px' }}><div style={{ color: "white" }}>&bull;</div> User Manager</MenuItem>;
    }

    if (this.state.showUserManager === true) {
      userManager =
        <NewWindow title={'User Manager'} name={'User Manager'} onUnload={this.handleCloseUserManager} center='screen' features={this.state.userManagerfeatureSize}>
          <ManageUser />
        </NewWindow>;
    }

    if (userRoles.includes("A")) {
      groupManagerMenuItem =
        <MenuItem onClick={this.handleShowGroupManager} style={{ padding: '5px 10px', fontSize: '12px', minHeight: '25px' }}><div style={{ color: "white" }}>&bull;</div> Group Manager</MenuItem>;
    }

    if (this.state.showGroupManager === true) {
      groupManager =
        <NewWindow title={'Group Manager'} name={'Group Manager'} onUnload={this.handleCloseGroupManager} center='screen' features={this.state.groupManagerfeatureSize}>
          <ManageGroup />
        </NewWindow>;
    }

    // Make Announcement (part of MenuItem)style={{ padding: '5px 10px', fontSize: '12px', minHeight: '25px' }} (inside MenuItem)<div style={{ color: "white" }}> &bull;</div>
    let announcementMenuItem = <MenuItem onClick={this.handleShowMakeAnnouncement} style={{ padding: '5px 10px', fontSize: '12px', minHeight: '25px' }}><div style={{ color: "white" }}>&bull;</div> Make Announcement</MenuItem>;
    if (this.state.showMakeAnnouncement === true) {
        announcement =
            <NewWindow name={'Make Announcement'} onUnload={this.handleCloseMakeAnnouncement} center='screen' features={this.state.announcementfeatureSize} title={'Make Announcement'}>
                <Announcement />
            </NewWindow>;
    }

    // Announcement Message
    let announcements = [];
    for (var i = 0; i < this.state.announcements.length; i++) {
        console.log("Pushing Announcements!");
       
        console.log(this.state.announcements);
        announcements.push(
            <NewWindow name={'Announcement'} onUnload={this.closeAnnouncement(this.state.announcements[i])} features={this.state.announcementMessagefeatureSize} center={'screen'} title={'Announcement'}>
                <AnnouncementMessage
                    announcement={this.state.announcements[i]}
                />
            </NewWindow>);
        /*
        announcement = <NewWindow name={'Announcement'} onUnload={this.closeAnnouncement(this.state.announcements[i])} features={this.state.announcementMessagefeatureSize} center={'screen'} title={'Announcement'}>
            <AnnouncementMessage
                announcement={this.state.announcements[i]}
            />
        </NewWindow>;
        */
    }

    // OnCallSchedule on hold
    if (false) {
      onCallSchedule = <OnCallScheduleList callbackFromParent={this.handleCloseMainMenuCallback} />;
    }
    // var win = document.defaultView || document.parentWindow;
    // console.log("win", win);
    return (
        <div>
        {announcements}
        <AppBar position="static">
          <Toolbar style={{ padding: '0px', width: '200px' }}>
            <Grid container item justify="flex-start" spacing={0}>
              <Grid item xs={6}>
                <UserInfo />
              </Grid>
            <Grid container item xs={6} justify="flex-end" style={{}}>
                <div>
                  <IconButton
                    color="inherit"
                    aria-label="Menu"
                    aria-owns={anchorEl ? 'simple-menu' : undefined}
                    aria-haspopup="true"
                    onClick={this.handleClickMainMenu}
                  >
                    <Tooltip
                      placement="bottom"
                      enterDelay={500}
                      title={
                        <React.Fragment>
                          <h6>
                            Main Menu
                          </h6>
                        </React.Fragment>
                      }
                    >
                    <MenuIcon style={{ fontSize: '2.5rem' }} />
                    </Tooltip>
                  </IconButton>
                  <Menu
                    id="simple-menu1"
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={this.handleCloseMainMenu}
                    MenuListProps={{ style: { padding: '0px' } }}
                    //disableAutoFocusItem={true}
                    //autoFocus={false}
                  >
                    <Profile callbackFromParent={this.handleCloseMainMenuCallback} />
                    {onCallSchedule}
                    <MenuItem onClick={this.handleShowBulletin} style={{ padding: '5px 10px', fontSize: '12px', minHeight: '25px' }}><div style={{ color: "white" }}>&bull;</div> View Bulletin</MenuItem>
                    {userManagerMenuItem}
                    {groupManagerMenuItem}
                    {announcementMenuItem}
                    <MenuItem onClick={this.handleClickLogout} style={{ padding: '5px 10px', fontSize: '12px', minHeight: '25px' }}><div style={{ color: "white" }}>&bull;</div> Logout</MenuItem>
                  </Menu>
                </div>
                {bulletin}
                {userManager}
                {groupManager}
                {announcement}
                {/*{announcements}
                 */}
              </Grid>
            </Grid>
          </Toolbar>
        </AppBar>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  //currentUser: state.reducer.currentUser
    profile: state.profile, 
    hub: state.hub
})

const mapDispatchToProps = dispatch => ({
    //getProfileFetch: () => dispatch(getProfileFetch()),
    logoutUser: () => dispatch(logoutUser()),
    updateProfile: user => dispatch(getProfileFetch['UPDATE_PROFILE'](user)),
    setChatDisplay: shouldDisplay => dispatch(windowActions['SET_CHAT_DISPLAY'](shouldDisplay)),
    //updateLastSeen: () => dispatch(userActions['UPDATE_LAST_SEEN']()),
    updateLastSeen: (updateStamp) => dispatch(userActions['UPDATE_LAST_SEEN'](updateStamp)),
    updateStamp: () => dispatch(userActions['UPDATE_STAMP']()),
    updateBulletin: shouldDisplay => dispatch(windowActions['SET_BULLETIN'](shouldDisplay)),
})

export default connect(mapStateToProps, mapDispatchToProps)(UserHub);


// WEBPACK FOOTER //
// ./src/components/UserHub.js